import React, { useEffect, useRef } from 'react';
import { IPlaceItem } from '../constants';
import './index.module.less';
import ListItem from './ListItem';
import ScrollUtils from '@helpers/scrollUtils';
import { isInIos } from '@helpers/Constants';
//私有常量

//可抽离的逻辑处理函数/组件

let SearchList = (props: IProps) => {
  //变量声明、解构
  const { items, selectedLocation, onSelectItem, onCancel, onSearch } = props;
  const inputRef = useRef(null);

  //组件状态

  //网络IO

  //数据转换

  //逻辑处理函数
  const preventEvent = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const inputValue: React.ChangeEventHandler<HTMLInputElement> = e => {
    const value = e.target.value || '';
    onSearch(value);
  };

  const select = (item: IPlaceItem) => {
    inputRef.current.blur();
    onSelectItem && onSelectItem(item, true);
  };

  const renderLocations = (): JSX.Element | JSX.Element[] => {
    let Items = null;
    if (items?.length) {
      Items = items.map((item: IPlaceItem) => {
        return (
          <ListItem
            key={item.uniqueId}
            item={item}
            onSelect={select}
            selectItem={selectedLocation}
          />
        );
      });
    } else if (items && !items.length) {
      Items = <div styleName="empty">无结果</div>;
    }
    return Items;
  };

  const cancel = () => {
    inputRef.current.blur();
    setTimeout(() => {
      onCancel && onCancel();
    }, 100);
  };

  //组件Effect
  useEffect(() => {
    const { forbidScroll, allowScroll } = ScrollUtils('frequent-select-input');
    if (isInIos) {
      forbidScroll();
    }
    return () => {
      if (isInIos) {
        allowScroll();
      }
    };
  }, []);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  return (
    <div styleName="modal-mask" onClick={cancel}>
      <div
        className="flex"
        styleName="modal"
        style={{ height: '80%' }}
        onClick={preventEvent}
      >
        <div
          className="flex"
          styleName="input-wrapper"
          style={{ background: 'transparent' }}
        >
          <div className="flex" styleName="input-content">
            <i className="iconfont icon-sousuo" styleName="input-icon" />
            <input
              id="frequent-select-input"
              ref={inputRef}
              styleName="input"
              placeholder="搜索地点名称"
              onChange={inputValue}
              autoFocus={true}
            />
          </div>
          <div styleName="input-cancel" onClick={cancel}>
            取消
          </div>
        </div>
        <div styleName="list">{renderLocations()}</div>
      </div>
    </div>
  );
};

//props类型定义
interface IProps {
  items: IPlaceItem[] | null;
  selectedLocation: IPlaceItem;
  /**
   * 点击位置List切换位置事件
   */
  onSelectItem: (item: IPlaceItem, isSearch?: boolean) => void;
  /**
   * 取消搜索状态
   */
  onCancel: () => void;
  /**
   * 根据搜索框内容搜索
   */
  onSearch: (value: string) => void;
}

//prop-type定义，可选

export default SearchList;
